import { render, staticRenderFns } from "./PanelResizable.vue?vue&type=template&id=f054f85a&scoped=true"
import script from "./PanelResizable.vue?vue&type=script&lang=js"
export * from "./PanelResizable.vue?vue&type=script&lang=js"
import style0 from "./PanelResizable.vue?vue&type=style&index=0&id=f054f85a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f054f85a",
  null
  
)

export default component.exports